namespace SP {
    export interface RefundInfo {
        refundId: string,
        refundDate: string,
        order: OrderInfo,
        use: string,
        currency: string,
        total: number,
        totalIncVat: number,
        returnFee: number,
        returnFeeIncVat: number,
        refundType: RefundType,
        lines: RefundLineInfo[],
        confirmed: boolean
    }

    export interface RefundLineInfo {
        id: string,
        qty: number,
        refundPrice: number,
        refundPriceIncVat: number,
        balance: number,
        orderLine: OrderLineInfo,
    }

    export interface RefundBundleBalanceLine {
        orderLineId: string,
        totalPriceVatInc: number,
        staticBalance: number,
        balance: number,
    }
}